export default __webpack_public_path__ + "static/media/checked.12fdaf28.svg";